import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Why Us',
    href: '#why-us'
  }, {
    name: 'Commitment',
    href: '#commitment'
  }, {
    name: 'Contact',
    href: '#contact'
  }];
  const scrollToSection = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    setIsMobileMenuOpen(false);
    const element = document.querySelector(href);
    if (element) {
      const offset = 80; // height of navbar
      const bodyRect = document.body.getBoundingClientRect().top;
      const elementRect = element.getBoundingClientRect().top;
      const elementPosition = elementRect - bodyRect;
      const offsetPosition = elementPosition - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm py-4' : 'bg-white/95 backdrop-blur-sm py-6'}`} data-id="element-175">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-176">
        <div className="flex justify-between items-center" data-id="element-177">
          {/* Logo */}
          <a href="#hero" onClick={e => scrollToSection(e, '#hero')} className="group flex items-center gap-3" data-id="element-178">
            <img src="https://cdn.magicpatterns.com/uploads/s3bTrEvY6gpbmuLKno6jM2/KMC.png" alt="KMC Logo" className="h-10 w-auto" data-id="element-179" />
            <span className="text-xl font-bold text-charcoal tracking-wide" data-id="element-180">
              KINGSBURY
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-181">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-sm font-medium text-body hover:text-primary transition-colors" data-id="element-182">
                {link.name}
              </a>)}
            <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="px-5 py-2.5 text-sm font-medium text-white bg-primary hover:bg-primary-light transition-colors rounded-md shadow-sm" data-id="element-183">
              Request a Quote
            </a>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-charcoal" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-184">
            {isMobileMenuOpen ? <XIcon className="w-6 h-6" data-id="element-185" /> : <MenuIcon className="w-6 h-6" data-id="element-186" />}
          </button>
        </div>
      </div>

      {/* Mobile Nav Drawer */}
      <AnimatePresence data-id="element-187">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} className="absolute top-full left-0 right-0 bg-white shadow-lg border-t border-border md:hidden" data-id="element-188">
            <div className="flex flex-col px-4 py-6 space-y-4" data-id="element-189">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={e => scrollToSection(e, link.href)} className="text-base font-medium text-charcoal hover:text-primary transition-colors py-2" data-id="element-190">
                  {link.name}
                </a>)}
              <a href="#contact" onClick={e => scrollToSection(e, '#contact')} className="mt-4 px-5 py-3 text-center text-sm font-medium text-white bg-primary hover:bg-primary-light transition-colors rounded-md shadow-sm" data-id="element-191">
                Request a Quote
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}